/* =============================================================
   Nine Two Five Silver — theme.js
   Theme version: 1.6.12 (DRAFT — review before publish)   ·   Updated: 19 June 2026
   AJAX cart drawer + qty steppers + predictive search +
   sticky mobile PDP + gift-wrap upsell + custom-size note.
   ============================================================= */
(function(){
  'use strict';

  const $  = (sel, ctx=document) => ctx.querySelector(sel);
  const $$ = (sel, ctx=document) => Array.from(ctx.querySelectorAll(sel));
  const money = (cents, currency='GBP') => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(cents/100); }
    catch(e){ return '£' + (cents/100).toFixed(2); }
  };

  /* ------- Cart state ------- */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return await res.json();
  }
  async function addToCart(id, qty=1, props=null) {
    const body = { id, quantity: qty };
    if (props) body.properties = props;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return await res.json();
  }
  async function updateLine(line, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: qty }),
    });
    return await res.json();
  }

  /* ------- Drawer open/close ------- */
  function openDrawer() {
    const scrim  = $('#cart-scrim');
    const drawer = $('#cart-drawer');
    if (!scrim || !drawer) return;
    scrim.classList.add('is-open');
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    const scrim  = $('#cart-scrim');
    const drawer = $('#cart-drawer');
    if (!scrim || !drawer) return;
    scrim.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* ------- Render drawer body ------- */
  function renderLineProps(props) {
    if (!props) return '';
    const esc = (s) => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
    const rows = Object.keys(props).filter(k =>
      k.charAt(0) !== '_' && k !== 'Send method' && props[k] != null && String(props[k]).trim() !== ''
    );
    if (!rows.length) return '';
    return '<ul class="cart-item__properties">' +
      rows.map(k => `<li><span class="cart-item__property-label">${esc(k)}:</span> ${esc(props[k])}</li>`).join('') +
      '</ul>';
  }

  function renderCart(cart) {
    const body = $('#cart-drawer-body');
    const subEl = $('#cart-subtotal');
    const countEl = $$('.cart-toggle');
    const emptyText = document.documentElement.dataset.cartEmptyText || 'Nothing here yet!';

    countEl.forEach(el => {
      el.setAttribute('data-count', cart.item_count);
      const c = $('.cart-toggle__count', el); if (c) c.textContent = cart.item_count;
    });

    if (!cart.item_count) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="title">${emptyText.split('!')[0]}!</div>
          <div class="sub">${emptyText.split('!').slice(1).join('!').trim() || 'Browse the collection and grab something shiny.'}</div>
        </div>`;
      if (subEl) subEl.textContent = money(0, cart.currency);
      return;
    }

    body.innerHTML = cart.items.map((item, idx) => `
      <div class="line-item" data-line="${idx + 1}">
        <div class="line-item__img">
          ${item.image ? `<img src="${item.image}" alt="${(item.product_title || '').replace(/"/g, '&quot;')}">` : ''}
        </div>
        <div>
          <div class="line-item__name">${item.product_title}</div>
          <div class="line-item__variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : item.product_type || ''}</div>
          ${renderLineProps(item.properties)}
          <div style="display:flex;align-items:center;gap:10px;margin-top:8px;">
            <div class="qty-stepper">
              <button data-action="dec" aria-label="Decrease quantity">
                <svg class="icon" width="12" height="12" viewBox="0 0 24 24"><path d="M5 12h14"/></svg>
              </button>
              <span>${item.quantity}</span>
              <button data-action="inc" aria-label="Increase quantity">
                <svg class="icon" width="12" height="12" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>
              </button>
            </div>
            <button class="line-item__remove" data-action="remove">Remove</button>
          </div>
        </div>
        <div class="line-item__price">${money(item.final_line_price, cart.currency)}</div>
      </div>
    `).join('');

    if (subEl) subEl.textContent = money(cart.total_price, cart.currency);
  }

  async function refreshCart() {
    try { renderCart(await fetchCart()); }
    catch(e) { console.error('cart refresh failed', e); }
  }

  /* ------- Bind events ------- */
  function bind() {
    // Open/close drawer
    $$('.cart-toggle').forEach(b => b.addEventListener('click', e => {
      e.preventDefault(); openDrawer();
    }));
    const closeBtn = $('#cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    const scrim = $('#cart-scrim');
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeDrawer();
    });

    // Mobile nav drawer (§6, v1.6.12)
    const mnav = $('#mobile-nav');
    const openMobile = () => {
      if (!mnav) return;
      mnav.classList.add('is-open');
      mnav.setAttribute('aria-hidden', 'false');
      $$('[data-mobile-nav-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
    };
    const closeMobile = () => {
      if (!mnav) return;
      mnav.classList.remove('is-open');
      mnav.setAttribute('aria-hidden', 'true');
      $$('[data-mobile-nav-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
    };
    $$('[data-mobile-nav-open]').forEach(b => b.addEventListener('click', openMobile));
    $$('[data-mobile-nav-close]').forEach(b => b.addEventListener('click', closeMobile));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMobile(); });

    // Mobile nav groups (v1.6.17): tap a group row to open it; opening one
    // closes the others so the list fits without scrolling on a normal phone.
    const groups = mnav ? Array.from(mnav.querySelectorAll('[data-mobile-group]')) : [];
    const setGroup = (li, open) => {
      const btn = li.querySelector('[data-mobile-group-toggle]');
      const wrap = li.querySelector('.mobile-nav__sub-wrap');
      li.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (wrap) wrap.hidden = !open;
    };
    groups.forEach(li => {
      const btn = li.querySelector('[data-mobile-group-toggle]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const open = !li.classList.contains('is-open');
        groups.forEach(other => { if (other !== li) setGroup(other, false); });
        setGroup(li, open);
        if (open) li.scrollIntoView({ block: 'nearest' });
      });
    });

    // Add to cart (product form)
    $$('form[data-product-form]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        const fd = new FormData(form);
        const variantId = fd.get('id');
        const qty = parseInt(fd.get('quantity') || '1', 10);
        try {
          await addToCart(variantId, qty);
          await refreshCart();
          openDrawer();
        } catch(err) {
          console.error(err);
        } finally {
          if (btn) btn.disabled = false;
        }
      });
    });

    // Quantity + remove (delegated)
    const body = $('#cart-drawer-body');
    if (body) {
      body.addEventListener('click', async e => {
        const btn = e.target.closest('button[data-action]');
        if (!btn) return;
        const line = parseInt(btn.closest('.line-item').dataset.line, 10);
        const cart = await fetchCart();
        const current = cart.items[line - 1];
        if (!current) return;
        let qty = current.quantity;
        if (btn.dataset.action === 'inc') qty++;
        else if (btn.dataset.action === 'dec') qty = Math.max(0, qty - 1);
        else if (btn.dataset.action === 'remove') qty = 0;
        await updateLine(line, qty);
        await refreshCart();
      });
    }

    // Product gallery thumbnails
    $$('.product-gallery__thumbs').forEach(strip => {
      strip.addEventListener('click', e => {
        const thumb = e.target.closest('.product-gallery__thumb');
        if (!thumb) return;
        const src = thumb.dataset.src;
        if (!src) return;
        $$('.product-gallery__thumb', strip).forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const main = $('#product-main-image');
        if (main) main.src = src;
      });
    });

    // Delivery line under the price (#251): follows the selected variant's stock,
    // and reads "made to order" while the custom-size box is open or has text.
    const stockState = el => {
      if (!el || !el.dataset.inventoryManagement) return 'in'; // untracked counts as in stock
      const q = parseInt(el.dataset.inventoryQuantity, 10);
      if (isNaN(q)) return 'in';
      return q <= 0 ? 'made' : (q === 1 ? 'one' : 'in');
    };
    const refreshShippingNote = form => {
      const line = $('[data-shipping-note]');
      if (!line || !form) return;
      const note = form.querySelector('[data-custom-size-note]');
      const ta = note && note.querySelector('textarea');
      let state, available = true;
      if (note && (!note.hasAttribute('hidden') || (ta && ta.value.trim()))) {
        state = 'made';
      } else {
        const input = form.querySelector('input[name="id"]');
        const pill = input && form.querySelector(`[data-variant-id="${input.value}"]`);
        if (!pill) return; // single-variant product: the server-rendered line stands
        state = stockState(pill);
        available = pill.dataset.available !== 'false';
      }
      const text = line.dataset['text' + state.charAt(0).toUpperCase() + state.slice(1)];
      if (text) line.textContent = text;
      line.hidden = !available;
    };
    $$('[data-custom-size-note] textarea').forEach(ta => {
      ta.addEventListener('input', () => refreshShippingNote(ta.closest('form')));
    });

    // Variant size/option pickers (PDP)
    $$('[data-option-picker]').forEach(group => {
      group.addEventListener('click', e => {
        handleOptionClick(e);
        refreshShippingNote(group.closest('form'));
      });
      function handleOptionClick(e) {
        // Handle the "Custom size" toggle separately
        const customToggle = e.target.closest('[data-custom-size-toggle]');
        if (customToggle) {
          const sizeGroup = customToggle.closest('[data-size-group]');
          const note = sizeGroup && sizeGroup.querySelector('[data-custom-size-note]');
          const willOpen = note && note.hasAttribute('hidden');
          if (note) {
            if (willOpen) {
              note.removeAttribute('hidden');
              customToggle.classList.add('is-active');
              customToggle.setAttribute('aria-expanded', 'true');
              customToggle.textContent = '✓ Custom size';
              // Deselect any selected size chip — custom size takes precedence
              $$('.size-chip', group).forEach(c => {
                if (c !== customToggle) c.classList.remove('is-active');
              });
              setTimeout(() => note.querySelector('textarea')?.focus(), 120);
            } else {
              note.setAttribute('hidden', '');
              customToggle.classList.remove('is-active');
              customToggle.setAttribute('aria-expanded', 'false');
              customToggle.textContent = '+ Custom size';
              const ta = note.querySelector('textarea'); if (ta) ta.value = '';
            }
          }
          return;
        }

        const pill = e.target.closest('.option-pill, .size-chip:not([data-custom-size-toggle])');
        if (!pill || pill.classList.contains('is-sold-out')) return;
        // If a real size is picked, close the custom-size note
        const sizeGroup = pill.closest('[data-size-group]');
        if (sizeGroup) {
          const note = sizeGroup.querySelector('[data-custom-size-note]');
          const customToggle = sizeGroup.querySelector('[data-custom-size-toggle]');
          if (note && !note.hasAttribute('hidden')) {
            note.setAttribute('hidden', '');
            const ta = note.querySelector('textarea'); if (ta) ta.value = '';
          }
          if (customToggle) {
            customToggle.classList.remove('is-active');
            customToggle.setAttribute('aria-expanded', 'false');
            customToggle.textContent = '+ Custom size';
          }
        }
        $$('.option-pill, .size-chip', group).forEach(p => {
          if (!p.hasAttribute('data-custom-size-toggle')) p.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        // Update hidden variant input if data-variant-id provided (#90), and reflect availability on the buy button
        const variantId = pill.dataset.variantId;
        if (variantId) {
          const form = group.closest('form');
          const input = form && form.querySelector('input[name="id"]');
          if (input) input.value = variantId;
          const available = pill.dataset.available !== 'false';
          const submit = form && form.querySelector('button[type="submit"]');
          if (submit) {
            submit.disabled = !available;
            const label = submit.querySelector('span');
            if (label) label.textContent = available ? 'Add to bag · I want this one!' : 'Sold out';
          }
          // Let other scripts (wishlist.js) follow the chosen size.
          (form || document).dispatchEvent(new CustomEvent('ntf:variant:change', { bubbles: true, detail: { variantId, available } }));
        }
      }
    });

    // Filter rail (collection page) — toggle active state, follow link
    $$('.rail-group a').forEach(a => {
      a.addEventListener('click', () => {
        const ul = a.closest('ul');
        if (ul) $$('a', ul).forEach(x => x.classList.remove('is-active'));
        a.classList.add('is-active');
      });
    });
  }

  /* ------- Predictive search ------- */
  let searchTimer = null;
  let searchActiveIndex = -1;
  function openSearch() {
    const o = $('#search-overlay');
    if (!o) return;
    o.classList.add('is-open');
    o.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const input = $('#search-input');
    if (input) setTimeout(() => input.focus(), 50);
  }
  function closeSearch() {
    const o = $('#search-overlay');
    if (!o) return;
    o.classList.remove('is-open');
    o.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  async function predictiveSearch(q) {
    const results = $('#search-results');
    if (!results) return;
    if (!q || q.length < 2) { results.innerHTML = ''; searchActiveIndex = -1; return; }
    try {
      // Theme setting "Hide seconds from site search" (#334): ask for the maximum of 10 and drop that tag
      // here, since "-tag:seconds" in the query pads results with unrelated products.
      const overlay = $('#search-overlay');
      const hideTag = overlay && overlay.dataset.hideTag;
      const limit = hideTag ? 10 : 6;
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=${limit}&resources[options][unavailable_products]=last`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const r = (data.resources && data.resources.results) || {};
      if (hideTag && r.products) {
        r.products = r.products.filter(p => !(p.tags || []).includes(hideTag)).slice(0, 6);
      }
      if (hideTag) ['articles', 'pages'].forEach(k => { if (r[k]) r[k] = r[k].slice(0, 6); });
      const groups = [];

      if (r.products && r.products.length) {
        groups.push(`<div class="search-overlay__group">
          <h3>Pieces</h3>
          ${r.products.map(p => `
            <a class="search-result" href="${p.url}">
              <div class="search-result__img">${p.image ? `<img src="${p.image}" alt="${(p.title || '').replace(/"/g, '&quot;')}">` : ''}</div>
              <div>
                <div class="search-result__type">${p.vendor || '925 sterling'}</div>
                <div class="search-result__title">${p.title}</div>
                <div class="search-result__price">${p.price || ''}</div>
              </div>
            </a>`).join('')}
        </div>`);
      }
      if (r.articles && r.articles.length) {
        groups.push(`<div class="search-overlay__group">
          <h3>Journal</h3>
          ${r.articles.map(a => `
            <a class="search-result" href="${a.url}">
              <div class="search-result__img" style="background: var(--ntf-cream-soft);">${a.image ? `<img src="${a.image}" alt="${(a.title || '').replace(/"/g, '&quot;')}">` : ''}</div>
              <div><div class="search-result__type">Article</div><div class="search-result__title">${a.title}</div></div>
            </a>`).join('')}
        </div>`);
      }
      if (r.pages && r.pages.length) {
        groups.push(`<div class="search-overlay__group">
          <h3>Pages</h3>
          ${r.pages.map(p => `
            <a class="search-result" href="${p.url}">
              <div class="search-result__img"></div>
              <div><div class="search-result__type">Page</div><div class="search-result__title">${p.title}</div></div>
            </a>`).join('')}
        </div>`);
      }
      results.innerHTML = groups.length
        ? groups.join('') + `<div class="search-overlay__group"><a class="search-result" href="/search?q=${encodeURIComponent(q)}&type=product" style="font-weight:600;"><div class="search-result__img"></div><div><div class="search-result__type">All results</div><div class="search-result__title">See everything matching "${q}" →</div></div></a></div>`
        : `<div class="search-overlay__group"><p style="color: var(--ntf-charcoal-2); font-size: 14px;">Nothing found for "${q}" yet. Try a different word?</p></div>`;
      searchActiveIndex = -1;
    } catch (err) {
      console.error('predictive search failed', err);
    }
  }
  function navSearchResults(dir) {
    const results = $$('#search-results .search-result');
    if (!results.length) return;
    searchActiveIndex = Math.max(0, Math.min(results.length - 1, searchActiveIndex + dir));
    results.forEach((r, i) => r.classList.toggle('is-active', i === searchActiveIndex));
    results[searchActiveIndex].scrollIntoView({ block: 'nearest' });
  }
  function bindSearch() {
    $$('.site-header__search-toggle').forEach(b => b.addEventListener('click', openSearch));
    const closeBtn = $('#search-close');
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    const overlay = $('#search-overlay');
    if (overlay) overlay.addEventListener('click', e => { if (e.target === overlay) closeSearch(); });
    const input = $('#search-input');
    if (input) {
      input.addEventListener('input', e => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => predictiveSearch(e.target.value.trim()), 180);
      });
      input.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') { e.preventDefault(); navSearchResults(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); navSearchResults(-1); }
        else if (e.key === 'Enter' && searchActiveIndex >= 0) {
          e.preventDefault();
          const r = $$('#search-results .search-result')[searchActiveIndex];
          if (r) r.click();
        }
      });
    }
    $$('.search-overlay__chip').forEach(chip => chip.addEventListener('click', () => {
      const i = $('#search-input'); if (!i) return;
      i.value = chip.dataset.prefill; i.focus();
      predictiveSearch(chip.dataset.prefill);
    }));
    // / shortcut + Esc handled in global keydown
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) closeSearch();
      else if (e.key === '/' && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
        e.preventDefault(); openSearch();
      }
    });
  }

  /* ------- Sticky mobile add-to-cart on PDP ------- */
  function bindStickyPdp() {
    const sticky = $('.pdp-sticky');
    const mainCta = $('form[data-product-form] button[type="submit"]');
    if (!sticky || !mainCta) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(mainCta);
    const stickyBtn = $('.pdp-sticky button');
    if (stickyBtn) stickyBtn.addEventListener('click', () => mainCta.click());
  }

  /* ------- Gift wrap upsell ------- */
  async function setGiftWrap(variantId, message) {
    // Remove any existing gift-wrap line from this product first.
    try {
      const cart = await fetchCart();
      const gwEl = $('#giftwrap');
      const handle = gwEl && gwEl.dataset.productHandle;
      if (handle) {
        for (let i = cart.items.length; i >= 1; i--) {
          const line = cart.items[i - 1];
          if (line.handle === handle) {
            await updateLine(i, 0);
          }
        }
      }
      if (variantId) {
        await addToCart(variantId, 1, message ? { 'Card message': message } : null);
      }
      const fresh = await fetchCart();
      renderCart(fresh);
      // Re-sync the giftwrap UI to the new state
      syncGiftWrapUI(fresh);
    } catch (err) { console.error('gift wrap update failed', err); }
  }

  function syncGiftWrapUI(cart) {
    const wrap = $('#giftwrap');
    if (!wrap) return;
    const handle = wrap.dataset.productHandle;
    const item = cart.items.find(it => it.handle === handle);
    $$('.giftwrap__opt', wrap).forEach(b => b.classList.remove('is-active'));
    const note = $('[data-giftwrap-note]', wrap);
    const msg  = $('[data-giftwrap-msg]', wrap);
    const counter = $('[data-giftwrap-msg-count]', wrap);
    if (item) {
      const active = $(`.giftwrap__opt[data-giftwrap-variant="${item.variant_id}"]`, wrap);
      if (active) active.classList.add('is-active');
      if (note) note.removeAttribute('hidden');
      if (msg)  msg.value = (item.properties && item.properties['Card message']) || '';
    } else {
      const none = $('[data-giftwrap-clear]', wrap);
      if (none) none.classList.add('is-active');
      if (note) note.setAttribute('hidden', '');
      if (msg)  msg.value = '';
    }
    if (counter && msg) counter.textContent = msg.value.length;
  }

  function bindGiftWrap() {
    const wrap = $('#giftwrap');
    if (!wrap) return;
    const msgInput = $('[data-giftwrap-msg]', wrap);
    const counter  = $('[data-giftwrap-msg-count]', wrap);
    if (msgInput && counter) {
      msgInput.addEventListener('input', () => { counter.textContent = msgInput.value.length; });
      // Debounce: when user pauses typing for 600ms and a variant is active, sync message.
      let t = null;
      msgInput.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const active = $('.giftwrap__opt.is-active[data-giftwrap-variant]', wrap);
          if (active) setGiftWrap(active.dataset.giftwrapVariant, msgInput.value.trim());
        }, 600);
      });
    }
    wrap.addEventListener('click', e => {
      const opt = e.target.closest('.giftwrap__opt');
      if (!opt) return;
      if (opt.hasAttribute('data-giftwrap-clear')) {
        setGiftWrap(null, null);
      } else if (opt.dataset.giftwrapVariant) {
        const msg = msgInput ? msgInput.value.trim() : '';
        setGiftWrap(opt.dataset.giftwrapVariant, msg);
      }
    });
  }

  /* ------- Gift voucher personalisation (CR-005) ------- */
  function bindGiftVoucher() {
    const form = $('[data-gift-voucher-form]');
    if (!form) return;

    const sendBuyer     = $('[data-gv-send-buyer]', form);
    const sendRecipient = $('[data-gv-send-recipient]', form);
    const emailField    = $('[data-gv-email-field]', form);
    const emailInput    = $('[data-gv-recipient-email]', form);
    const emailError    = $('[data-gv-email-error]', form);
    const nameInput     = $('[data-gv-recipient-name]', form);
    const messageInput  = $('[data-gv-message]', form);
    const fromInput     = $('[data-gv-from]', form);
    const counter       = $('[data-gv-count]', form);
    const routeInput    = $('[data-gv-shopify-route]', form);
    const MESSAGE_MAX   = 200; // what fits on the A6 card

    const isValidEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((v || '').trim());

    function syncSendMethod() {
      const toRecipient = sendRecipient && sendRecipient.checked;
      if (emailField) emailField.hidden = !toRecipient;
      if (!toRecipient && emailError) { emailError.hidden = true; }
      if (!toRecipient && emailInput) { emailInput.classList.remove('gv-invalid'); }
      // The native flag carries "1" when sending direct to the recipient, which
      // tells Shopify to email the gift card to `Recipient email` with the
      // `Message` + buyer-as-sender injected automatically.
      if (routeInput) {
        routeInput.value = (toRecipient && emailInput && isValidEmail(emailInput.value)) ? '1' : '';
      }
    }

    if (sendBuyer)     sendBuyer.addEventListener('change', syncSendMethod);
    if (sendRecipient) sendRecipient.addEventListener('change', syncSendMethod);
    if (emailInput)    emailInput.addEventListener('input', syncSendMethod);

    if (messageInput && counter) {
      const updateCount = () => { counter.textContent = messageInput.value.length; };
      messageInput.addEventListener('input', updateCount);
      updateCount();
    }

    // Live preview (v1.6.17). The postcard beside the form is the same snippet
    // the real voucher renders; the fields drive its name, amount, message
    // and sign-off as the buyer types.
    const preview = $('[data-gv-preview]', form);
    if (preview) {
      const part = (k) => preview.querySelector('[data-gcp="' + k + '"]');
      const el = { forWord: part('for'), to: part('to'), amount: part('amount'), message: part('message'), lines: part('lines'), from: part('from'), sender: part('sender') };
      const syncPreview = () => {
        const name = nameInput ? nameInput.value.trim() : '';
        const msg  = messageInput ? messageInput.value.trim().slice(0, MESSAGE_MAX) : '';
        const from = fromInput ? fromInput.value.trim() : '';
        const tile = form.querySelector('input[name="id"]:checked');
        if (el.to) { el.to.textContent = name; el.to.hidden = !name; }
        if (el.forWord) el.forWord.hidden = !name;
        if (el.amount && tile && tile.dataset.gvAmount) el.amount.textContent = tile.dataset.gvAmount;
        if (el.message) { el.message.textContent = msg; el.message.hidden = !msg; }
        if (el.lines) el.lines.hidden = !!msg;
        if (el.sender) el.sender.textContent = from;
        if (el.from) el.from.hidden = !from;
      };
      [nameInput, messageInput, fromInput].forEach((i) => { if (i) i.addEventListener('input', syncPreview); });
      form.querySelectorAll('input[name="id"]').forEach((r) => r.addEventListener('change', syncPreview));
      syncPreview();
    }

    // Validate in the CAPTURE phase. The gift-voucher form manages its own
    // add-to-cart so this handler fully owns submit — there is no generic
    // data-product-form handler on this form. Digital-only (v1.6.11): no
    // printed/posted add-on line.
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Strip any HTML from the free-text fields before they reach the cart.
      if (messageInput) messageInput.value = messageInput.value.replace(/<[^>]*>/g, '').slice(0, MESSAGE_MAX);
      if (nameInput)    nameInput.value    = nameInput.value.replace(/<[^>]*>/g, '');
      if (fromInput)    fromInput.value    = fromInput.value.replace(/<[^>]*>/g, '');
      syncSendMethod();
      const toRecipient = sendRecipient && sendRecipient.checked;
      if (toRecipient && !isValidEmail(emailInput && emailInput.value)) {
        if (emailError) emailError.hidden = false;
        if (emailInput) { emailInput.classList.add('gv-invalid'); emailInput.focus(); }
        return false;
      }

      // Gather line-item properties from the form (skip blanks; keep the
      // underscore routing prop so Shopify still emails the recipient).
      const props = {};
      form.querySelectorAll('[name^="properties["]').forEach((el) => {
        const m = el.name.match(/^properties\[(.+)\]$/);
        if (!m) return;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        const val = (el.value || '').trim();
        if (val === '') return;
        props[m[1]] = val;
      });

      // The denomination tiles are radios all named "id", so take the CHECKED
      // one. A bare `input[name="id"]` lookup returns the first tile (£10)
      // whatever the buyer picked.
      const mainInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      const mainId = mainInput && mainInput.value;
      if (!mainId) return false;

      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      try {
        await addToCart(mainId, 1, Object.keys(props).length ? props : null);
        await refreshCart();
        openDrawer();
      } catch (err) {
        console.error('gift voucher add failed', err);
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    }, true);

    syncSendMethod();
  }

  /* ------- Public API (used by wishlist.js for Add to bag from the wishlist page) ------- */
  window.NTF = { addToCart, refreshCart, openDrawer };

  /* ------- Init ------- */
  document.addEventListener('DOMContentLoaded', () => {
    bind();
    bindSearch();
    bindStickyPdp();
    bindGiftWrap();
    bindGiftVoucher();
    refreshCart();
  });
})();
